<!--
  ~ Copyright (c) GM Global Technology Operations LLC. All rights reserved.
  ~ This information is confidential and proprietary to GM Global Technology
  ~ Operations LLC and may not be used, modified, copied or distributed.
  -->


<div class="header {{themeService.themeCssClass}}">
    <div fxLayoutAlign="center">
        <h1 class="header">Hello  {{authService.userInfo.firstName}} {{authService.userInfo.lastName}}</h1>
        <a routerLink="/personal">
            <button class="empButtons" mat-raised-button color="primary" type="button">Vacation</button>
        </a>
        <a routerLink="/work-abroad">
            <button class="empButtons" mat-raised-button color="primary" type="button">Work Abroad</button>
        </a>
        <a *ngIf="userService.hasRole('abt_manager') || userService.hasRole('Managers_IRL_Autopop')" routerLink="/team">
            <button class="empButtons" mat-raised-button color="primary" type="button">Team</button>
        </a>
        <a *ngIf="userService.hasRole('abt_hr')" routerLink="/company">
            <button class="empButtons" mat-raised-button color="primary" type="button">Company</button>
        </a>
    </div>
</div>
<div fxLayoutAlign="center">
    <footer class="header">
        <p>Please refer to the <a class="bold" target="_blank" rel="noopener noreferrer"
              href="https://socrates.gm.com/content/dam/socrates/documents/irl/Documents/Ireland-Vacation-Tracker-User-Guide_Employees-and-Managers_V1.pdf">User Guide</a> for more information</p>
    </footer>
</div>
